import { render, staticRenderFns } from "./SaveCard.vue?vue&type=template&id=8d9a3a32&scoped=true&"
import script from "./SaveCard.vue?vue&type=script&lang=js&"
export * from "./SaveCard.vue?vue&type=script&lang=js&"
import style0 from "./SaveCard.vue?vue&type=style&index=0&id=8d9a3a32&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d9a3a32",
  null
  
)

export default component.exports